import { render } from "./BaseCardCompact.vue?vue&type=template&id=b7d89472"
import script from "./BaseCardCompact.vue?vue&type=script&lang=js"
export * from "./BaseCardCompact.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseCardCompact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7d89472"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7d89472', __exports__)) {
    console.log('reload')
    api.reload('b7d89472', __exports__)
  }
  
  module.hot.accept("./BaseCardCompact.vue?vue&type=template&id=b7d89472", () => {
    console.log('re-render')
    api.rerender('b7d89472', render)
  })

}


export default __exports__